module.exports = __webpack_public_path__ + "img/default.9f9aa850.png";